module.exports = __webpack_public_path__ + "static/media/CreateReturn3.a526701b.png";